import React from 'react';

import chrome from '../img/chrome-icon.png';
import firefox from '../img/firefox-icon.png';
import safari from '../img/safari-icon.png';

import '../css/MobileLandscapeMessage.css';

const IEOverlay = () => {
    return (
        <div className="mobile-landscape-message-container">
            <div>

            </div>
            <div className="mobile-landscape-message-title">
                For the best experience, please use one of the following supported browsers:
            </div>
            <div className="flex">
                <div>
                    <a href="https://www.google.com/chrome/" target="_blank">
                        <img src={chrome} className="ie-overlay-browser-icon" alt="Chrome" />
                    </a>
                </div>
                <div>
                    <a href="https://www.apple.com/safari/" target="_blank">
                        <img src={safari} className="ie-overlay-browser-icon" alt="Safari" />
                    </a>
                </div>
                <div>
                    <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">
                        <img src={firefox} className="ie-overlay-browser-icon" alt="Firefox" />
                    </a>
                </div>
            </div>
            <div className="mobile-landscape-message-subtitle">
                Thanks for understanding!
            </div>
        </div>
    )
};

export default IEOverlay;


// WEBPACK FOOTER //
// ./src/components/IEOverlay.js